import { trackingSchema, type Tracking } from '@mrrmlab/shared-types';
import { z } from 'zod';
import type { HttpClient } from './http';

const trackingsArraySchema = z.array(trackingSchema);

export const createTrackingDtoSchema = z.object({
  trackingNumber: z.string().min(1).max(100),
  carrier: z.string().min(1).max(50).optional(),
  note: z.string().max(500).optional(),
});
export type CreateTrackingDto = z.infer<typeof createTrackingDtoSchema>;

export const trackingSyncResultSchema = z.object({
  registered: z.number().int().nonnegative(),
  updated: z.number().int().nonnegative(),
});
export type TrackingSyncResult = z.infer<typeof trackingSyncResultSchema>;

export class TrackingsResource {
  constructor(private readonly http: HttpClient) {}

  list(signal?: AbortSignal): Promise<Tracking[]> {
    return this.http.request({
      method: 'GET',
      path: '/trackings',
      responseSchema: trackingsArraySchema,
      signal,
    });
  }

  get(id: string, signal?: AbortSignal): Promise<Tracking> {
    return this.http.request({
      method: 'GET',
      path: `/trackings/${encodeURIComponent(id)}`,
      responseSchema: trackingSchema,
      signal,
    });
  }

  create(dto: CreateTrackingDto, signal?: AbortSignal): Promise<Tracking> {
    return this.http.request({
      method: 'POST',
      path: '/trackings',
      body: dto,
      responseSchema: trackingSchema,
      signal,
    });
  }

  sync(signal?: AbortSignal): Promise<TrackingSyncResult> {
    return this.http.request({
      method: 'POST',
      path: '/trackings/sync',
      responseSchema: trackingSyncResultSchema,
      signal,
    });
  }
}
